import React from 'react';

import { ROW_HEIGHT } from '../../constants';
import { getBlockStyle, toMinutes } from '../../helpers';
import styles from '../../index.module.scss';
import type { ProgramBlock } from '../../types';

type PreviewBlockProps = {
  draggedBlock: ProgramBlock;
  newStart: string;
  newEnd: string;
  isRestricted?: boolean;
  isTimeLimit?: boolean;
};

export const PreviewBlock: React.FC<PreviewBlockProps> = ({
  draggedBlock,
  newStart,
  newEnd,
  isRestricted = false,
  isTimeLimit,
}) => {
  const previewData = {
    ...draggedBlock,
    start: newStart,
    end: newEnd,
  };

  const startMinutes = toMinutes(newStart);
  const endMinutes = toMinutes(newEnd);
  const durationMinutes = endMinutes - startMinutes;
  const heightRem = Math.max((durationMinutes / 60) * ROW_HEIGHT, 2.5);

  const finalHeight = isRestricted ? Math.max(heightRem, 4.5) : heightRem;

  const { top } = getBlockStyle(previewData, ROW_HEIGHT);

  const blockClassName = isRestricted
    ? styles.restrictedPreviewBlock
    : styles.previewBlock;

  const getRestrictedContent = () => {
    if (isTimeLimit) {
      return {
        title: '⚠️ 結束時間超限',
        time: `結束時間 ${newEnd} 超過 23:00`,
      };
    } else {
      return {
        title: '⚠️ 時間重疊衝突',
        time: '此時段已有其他項目安排',
      };
    }
  };

  const { title, time } = isRestricted
    ? getRestrictedContent()
    : { title: draggedBlock.label, time: `${newStart} - ${newEnd}` };

  return (
    <div
      className={blockClassName}
      style={{
        top,
        height: `${finalHeight}rem`,
        width: '100%',
        left: '0',
        zIndex: 99995,
        position: 'absolute',
      }}
    >
      <div className={styles.previewContent}>
        <div className={styles.previewTitle}>{title}</div>
        <div className={styles.previewTime}>{time}</div>
      </div>
    </div>
  );
};
